export enum TalentHuntFilterLocalStorageKeys {
  TALENT_HUNT_FILTER_VALUES = 'talent-hunt-filter-values',
}

export enum TalentRecommendationLocalStorageKey {
  HIDE_TALENT_RECOMMENDATION_BANNER_FOR_JOB_IDS = 'hideTalentRecommendationBannerForJobIds',
}
